module.exports = __webpack_public_path__ + "static/media/tiktok.60b52866.png";